/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dashboard_V2_Other_ModelsInputs */



/**
* | output |
* | --- |
* | "Other ({count})" |
*
* @param {Dashboard_V2_Other_ModelsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_v2_other_models = /** @type {((inputs: Dashboard_V2_Other_ModelsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_V2_Other_ModelsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Andere (${i?.count})`)
	return /** @type {LocalizedString} */ (`Other (${i?.count})`)
});